import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const courseTypeLocaleModule: LocaleModule = {
  name: "courseType",
  messages: { en: en, it: it },
};
